import { bootstrap } from './config/bootstrap';

// versions are provided by webpack define plugin
declare const PORTAL_VERSION: string;
declare const COMPONENTS_VERSION: string;
declare const REPORT_VERSION: string;
declare const SCHEMA_VERSION: string;
declare const CORE_VERSION: string;
declare const MAP_VERSION: string;
declare const ADVANCED_CREDITCARD_FLOW: boolean;
declare const ADVANCED_REGISTRATION_FLOW: boolean;
declare const NORGES_EIENDOMMER_ENABLED: boolean;
declare const NORGES_EIENDOMMER_REST: string;
declare const BACKEND_ENV: string;
declare const BUILD_DATE: string;

window['AMBITA_BUILD'] = {
  build: BUILD_DATE,
  portal: PORTAL_VERSION,
  components: COMPONENTS_VERSION,
  report: REPORT_VERSION,
  schema: SCHEMA_VERSION,
  core: CORE_VERSION,
  map: MAP_VERSION
};

window['AMBITA_CONFIG'] = {
  environment: BACKEND_ENV,
  isNorgesEiendommerNewEnabled: NORGES_EIENDOMMER_ENABLED,
  isAdvancedRegistrationFlowEnabled: ADVANCED_REGISTRATION_FLOW,
  isAdvancedCreditCardRegistrationFlowEnabled: ADVANCED_CREDITCARD_FLOW,
  rest: {
    norgesEiendommer: NORGES_EIENDOMMER_REST
  }
};

window.addEventListener('DOMContentLoaded', bootstrap);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./app/index.ts